import { render, staticRenderFns } from "./collegeUpdate.vue?vue&type=template&id=a9435a8a&"
import script from "./collegeUpdate.vue?vue&type=script&lang=js&"
export * from "./collegeUpdate.vue?vue&type=script&lang=js&"
import style0 from "./collegeUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports